export default __webpack_public_path__ + "static/media/report.c45bb4a7.png";